<mat-card class="selection-tile">
  <mat-card-content class="selection-tile__content">
    <div
      class="tile"
      [class]="{
        'tile--clickable': isTileClickable(),
        'tile--with-actions': showActionButton(),
      }"
      (click)="emitSelectEvent()"
    >
      @if (showRemoveButton()) {
        <button mat-icon-button class="tile__remove-button" (click)="removed.emit(); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      }

      <ng-content />

      @if (showActionButton() && actionIcon(); as actionIcon) {
        <button mat-icon-button class="tile__action-button">
          <mat-icon class="material-icons-outlined">{{ actionIcon }}</mat-icon>
        </button>
      }
    </div>
  </mat-card-content>
</mat-card>
